<template>
	<div class="userpage" :class="($store.state.mode === 'dark') ? 'userpage-dark' : 'false'">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'dark-header-active' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				Third-party software
			</div>
			<i v-on:click="$router.push('/Support')" class="material-icons">help</i>
		</div>
		<div class="submenu--wrapper">
			<div class="head">	
				<div class="title">
					Several fantastic pieces of software!
				</div>
				<span class="desc">Several fantastic pieces of free and open-source software that helped us today, we included the entire list below.</span>
			</div>
			<div class="body-content">
				<div v-for="(item, index) in thirdParty" :key="index" class="sub-title">
					<div class="features"><span class="dot"></span> {{ item.list }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mode: null,
			thirdParty: [ 
				{
					list: "Firebase"
				},
				{
					list: "Google OAuth 2.0"
				},
				{
					list: "Howler"
				},
				{
					list: "Material Icons"
				},
				{
					list: "NPM"
				},
				{
					list: "Undraw"
				},
				{
					list: "VueJS"
				},
				{
					list: "Vuex"
				},
				{
					list: "Vuefire"
				},
				{
					list: "Vue-ripple"
				},
				{
					list: "Vue-router"
				},
				{
					list: "Vue-touch"
				},
				{
					list: "MomentJS"
				},
			],
		}
	},
	mounted() {
		this.mode = localStorage.mode
	},
};
</script>